import { WritableAtom, atom } from "jotai";

export function atomWithToggle(
  initialValue?: boolean
): WritableAtom<boolean, unknown[], void> {
  const anAtom: WritableAtom<boolean, unknown[], void> = atom(
    initialValue ?? false,
    (get, set, nextValue) => {
      const update = nextValue ?? !get(anAtom);
      if (update !== get(anAtom)) {
        set(anAtom, update);
      }
    }
  );

  return anAtom;
}
